import * as React from 'react';
import ActionButton from '../ActionButton/ActionButton';
import { IActionButtonProps } from '../ActionButton/types';
import { Icon } from '../modules';

const enum ICON_ENUM {
  cart = 'cart',
}

interface IIconButtonProps extends IActionButtonProps {
  icon: keyof typeof ICON_ENUM;
}

const IconButton = ({ disabled, type, icon, children, onClick, className }: IIconButtonProps) => {
  return (
    <ActionButton disabled={disabled} type={type} onClick={onClick} className={`iconButton ${className ?? ''}`}>
      <>
        <Icon type={icon} className="iconButton__icon" />
        <span className="iconButton__children">{children}</span>
      </>
    </ActionButton>
  );
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/modules/IconButton/IconButton.tsx